import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, filter } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  // Default title could be empty or 'Dashboard'
  private titleSource = new BehaviorSubject<string>('');
  currentTitle$ = this.titleSource.asObservable();

  private allMenus: any[] = [];

  constructor(private router: Router) {
    // Listen to every successful navigation
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.refreshTitleFromUrl();
    });
  }

  setMenus(menus: any[]) {
    this.allMenus = menus;
    this.refreshTitleFromUrl();
  }

  setTitle(title: string) {
    this.titleSource.next(title);
  }

  private refreshTitleFromUrl() {
    if (this.allMenus.length === 0) return;

    const currentUrl = this.router.url;
    const match = this.allMenus.find(m => 
       currentUrl === m.routeLink || currentUrl.startsWith(m.routeLink + '/')
    );
    
    if (match) {
      this.titleSource.next(match.screenName);
    }
  }
}